module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createNewLeg":"New leg"},"no":{"createNewLeg":"Ny leg"}}')
  delete Component.options._Ctor
}
